export const prescreenEndpoints = {
  intro: '/prescreening/intro/{slug}',
  name: '/prescreening/{candidateJobId}/name',
  job: '/prescreening/{candidateJobId}/job',
  callStarted: '/prescreening/{candidateJobId}/events/call-started',
  session: '/prescreening/{candidateJobId}/session',
  result: '/prescreening/{candidateJobId}/result',
} as const;

export const PRESCREEN_OG_IMAGE_PATH = '/og-image.png';
export const PRESCREEN_COPY_VERSION = 'voice_intro_v2';

export const PRESCREEN_OG_DESCRIPTION =
  'A voice intro — about 8 minutes, on your schedule.';
